const dates = state => state.dates

const committees = state => state.committees

const reviewers = state => state.reviewers

const dictumTypes = state => state.dictumTypes

const dictums = state => state.dictums

const committeeDictums = state => state.committeeDictums

const assignedReviewers = state => state.assignedReviewers

const assignedReviewerDictums = state => state.assignedReviewerDictums

const protocolTaskAdvance = state => state.protocolTaskAdvance

export default {
	dates,
	committees,
	reviewers,
	dictumTypes,
	dictums,
	committeeDictums,
	assignedReviewers,
	assignedReviewerDictums,
	protocolTaskAdvance,
}
